export function view(name) {
  if (name?.endsWith('.html')) {
    return 'DraftTag'
  } else if (name?.endsWith('.pdf')) {
    return 'FinalTag'
  } else {
    return 'No'
  }
}
